export default __webpack_public_path__ + "static/media/pbn-service-blueprint.9aeb110e.webp";